type UnsubscribeListener = () => void;

const mediaQueryListener = (query: string, callback: (matches: boolean) => void): UnsubscribeListener => {
    const handleChange = () => {
        const matches = window.matchMedia(query)?.matches;

        callback(matches);
    };

    handleChange();

    const matchMedia = window.matchMedia(query);

    matchMedia.addEventListener('change', handleChange);

    return () => {
        matchMedia.removeEventListener('change', handleChange);
    };
};

export default mediaQueryListener;